import HttpService from "../util/HttpService";
class TwilioApiService {
    getTwilioToken = (username: string, roomName: string) => {

        return HttpService.post('/video/api/v2/twilio-service/token', JSON.stringify({
            identity: username,
            room: roomName
        }));
        // return HttpService.post(CONTEXT_PATH.concat(SERVICE_PATH).concat('token'), JSON.stringify({
        //     identity: username,
        //     room: roomName
        // }));
    }
}

const twilioApiService = new TwilioApiService();
export default twilioApiService;